module.exports = __webpack_public_path__ + "ty9-a29d0346.png";